import { Button, Divider, Form } from "antd";
import { Event } from "@ticketingplatform/api/dist/event/fragments/__generated__/event";
import { useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import uniqBy from "lodash/uniqBy";

import { UseDiscountCodeForm } from "./types";
import * as Styled from "./styles";

export const useDiscountCodeForm: UseDiscountCodeForm = (form) => {
  const intl = useIntl();
  const [eventDropdownOpen, setEventDropdownOpen] = useState(false);
  const events = Form.useWatch<Event[]>(["input", "events"], form);
  const isApplicableToAllEvents = Form.useWatch<boolean>(
    ["input", "isApplicableToAllEvents"],
    form
  );

  return useMemo(
    () => ({
      eventOptions: (!isApplicableToAllEvents && events) || [],
      eventSelect: {
        open: eventDropdownOpen,
        onDropdownVisibleChange: setEventDropdownOpen,
        dropdownRender: (menu) => (
          <Styled.EventDropDownWrapper>
            <Button
              type="text"
              block
              onClick={() => {
                form.setFieldsValue({
                  input: {
                    events: [],
                    isApplicableToAllEvents: true,
                  },
                });
                setEventDropdownOpen(false);
              }}
            >
              <FormattedMessage defaultMessage="All Events" />
            </Button>
            <Divider />
            {menu}
          </Styled.EventDropDownWrapper>
        ),
        onChange(event) {
          if (!event) {
            form.setFieldsValue({
              input: {
                isApplicableToAllEvents: false,
              },
            });

            return;
          }

          form.setFieldsValue({
            input: {
              events: uniqBy([...events, event], "id"),
              isApplicableToAllEvents: false,
            },
          });
        },
        value: isApplicableToAllEvents
          ? ({
              name: intl.formatMessage({
                defaultMessage: "All Events",
              }),
            } as Event)
          : undefined,
      },
    }),
    [eventDropdownOpen, events, form, intl, isApplicableToAllEvents]
  );
};
